<div class="list-page">
  <div class="light-blue-text otsikko">
    <div style="margin-right: auto">
      <app-button (click)="back()" actionId="Navigoi taaksepäin" additionalClass="takaisin">
        <i class="icon ion-md-arrow-back takaisin-icon"></i>
      </app-button>
      Kirjanpitäjän asetukset
    </div>
  </div>
  <div class="alapalkki"></div>

  <div style="margin-left: 20px">
    <h3>Kirjanpito</h3>
    <mat-form-field style="width: 350px">
      <mat-label>Oletusraportti kirjanpidossa</mat-label>
      <mat-select [formField]="oletusraportti">
        @for (rap of kirjanpidonRaportit; track rap) {
          <mat-option [value]="rap.avain"> {{ rap.nimi }} </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <br />
    <mat-form-field style="width: 350px">
      <mat-label>Näkymissä, joissa on sekä tulos ja tase, näytetään...</mat-label>
      <mat-select [formField]="ensinNaytettavaRaportti">
        @for (rap of kumpiRaporttiEnsin; track rap) {
          <mat-option [value]="rap.avain"> {{ rap.nimi }} </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <br />

    <form>
      <h3>Tiedot</h3>
      <mat-form-field style="width: 350px">
        <mat-label>Puhelinnumero</mat-label>
        <input matInput type="tel" placeholder="Puhelinnumero" [formField]="lomake.phoneNumber" />
      </mat-form-field>

      <h3>Allekirjoituksen terveiset</h3>
      <div style="margin: 10px 0">
        Suomeksi:<br />
        <textarea cdkTextareaAutosize style="width: 350px; font-size: 14px" cdkAutosizeMinRows="4" type="text" [formField]="lomake.emailEndTextFi"></textarea>
      </div>
      <div style="margin: 10px 0">
        Englanniksi:<br />
        <textarea cdkTextareaAutosize style="width: 350px; font-size: 14px" cdkAutosizeMinRows="4" type="text" [formField]="lomake.emailEndTextEn"></textarea>
      </div>
      <div>
        <mat-checkbox [formField]="lomake.lomaviestiActive"> Lomaviesti </mat-checkbox>
      </div>
      @if (lomake.lomaviestiActive().value()) {
        <div>
          <div style="margin: 10px 0">
            Suomeksi:<br />
            <quill-editor [formField]="lomake.lomaviestiFi"></quill-editor>
          </div>
          <div style="margin: 10px 0">
            Englanniksi:<br />
            <quill-editor [formField]="lomake.lomaviestiEn"></quill-editor>
          </div>
        </div>
      }

      <div>
        <app-primary-button (click)="saveForm()" actionId="Tallenna kirjanpitäjän asetukset" [actionContext]="[$any(lomake().value())]" styles="margin: 25px 0;"> Tallenna </app-primary-button>
        @if (commonError()) {
          <div class="red-text">{{ commonError() }}</div>
        }
      </div>
    </form>

    <br />

    <h3>Sähköposti</h3>
    @if (kirjanpitajaObservable | async; as kirjanpitaja) {
      <div class="light-blue-text" style="margin: 5px 0; line-height: 15px; font-size: 15px; font-weight: bold">Allekirjoitus, suomi</div>
      <div #signature app-kirjanpito-lahetys-signature [kirjanpitajanNimitiedot]="kirjanpitaja" kieli="fi" [naytaRawHtml]="true"></div>
      <app-primary-button (click)="copySignature(kirjanpitaja, 'fi')" actionId="Kopioi kirjanpitäjän allekirjoitus (fi)" styles="margin-bottom: 20px;"> Kopioi allekirjoitus </app-primary-button>
      <div class="light-blue-text" style="margin: 5px 0; line-height: 15px; font-size: 15px; font-weight: bold">Allekirjoitus, englanti</div>
      <div #signature app-kirjanpito-lahetys-signature [kirjanpitajanNimitiedot]="kirjanpitaja" kieli="en" [naytaRawHtml]="true"></div>
      <app-primary-button (click)="copySignature(kirjanpitaja, 'en')" actionId="Kopioi kirjanpitäjän allekirjoitus (en)"> Kopioi allekirjoitus </app-primary-button>
    }
  </div>
</div>
